import React, { createContext, useContext, useState, useEffect } from 'react';

const CurrencyContext = createContext();

export const FALLBACK_CURRENCIES = [
  { code: 'AED', label: 'AED', flag: '🇦🇪', name: 'UAE Dirham', rate: 1 },
  { code: 'USD', label: 'USD', flag: '🇺🇸', name: 'US Dollar', rate: 0.272 },
  { code: 'GBP', label: 'GBP', flag: '🇬🇧', name: 'British Pound', rate: 0.215 },
  { code: 'EUR', label: 'EUR', flag: '🇪🇺', name: 'Euro', rate: 0.250 },
  { code: 'SAR', label: 'SAR', flag: '🇸🇦', name: 'Saudi Riyal', rate: 1.020 },
  { code: 'INR', label: 'INR', flag: '🇮🇳', name: 'Indian Rupee', rate: 22.65 },
  { code: 'PKR', label: 'PKR', flag: '🇵🇰', name: 'Pakistani Rupee', rate: 75.8  },
  { code: 'CNY', label: 'CNY', flag: '🇨🇳', name: 'Chinese Yuan', rate: 1.974 },
  { code: 'RUB', label: 'RUB', flag: '🇷🇺', name: 'Russian Ruble', rate: 24.8  },
  { code: 'QAR', label: 'QAR', flag: '🇶🇦', name: 'Qatari Riyal', rate: 0.990 }
];

export let GLOBAL_CURRENCIES = [...FALLBACK_CURRENCIES];

export function CurrencyProvider({ children }) {
  const [currencies, setCurrencies] = useState(FALLBACK_CURRENCIES);

  const fetchCurrencies = async () => {
    try {
      const res = await fetch((import.meta.env.VITE_API_URL || '') + '/api/settings');
      if (res.ok) {
        const data = await res.json();
        if (data && data.currencies) {
          setCurrencies(data.currencies);
          GLOBAL_CURRENCIES = data.currencies;
        }
      }
    } catch (e) {
      console.error('Failed to fetch currencies', e);
    }
  };

  useEffect(() => {
    fetchCurrencies();
  }, []);

  return (
    <CurrencyContext.Provider value={{ currencies, fetchCurrencies }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrencies() {
  const context = useContext(CurrencyContext);
  if (!context) {
    return { currencies: GLOBAL_CURRENCIES, fetchCurrencies: async () => {} };
  }
  return context;
}
